<template>
  <v-container v-if="user" fluid>
    <v-card-title class="teal lighten-2 accent-5 white--text">
      <v-row no-gutters class="pa-2">
        <v-col cols="12" md="6" class="mt-4"> Conteos Archivados </v-col>
        <v-col cols="12" md="5">
          <v-text-field
            @input="filtrarItems"
            v-model="search"
            append-icon="mdi-magnify"
            label="Búsqueda"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="mt-2">
          <v-btn
            :class="[
              {
                'disabled-button': selectedOption != 'abiertos',
                'enabled-button': selectedOption === 'abiertos',
              },
              'mr-1',
              'mb-1',
            ]"
            color="gray"
            @click="irA('Conteos')"
          >
            Abiertos y Cerrados
          </v-btn>
          <v-btn
            :class="[
              {
                'disabled-button': selectedOption != 'archivados',
                'enabled-button': selectedOption === 'archivados',
              },
              'mr-1',
              'ml-2',
              'mb-1',
            ]"
            color="gray"
            @click="irA('Conteos_Archivados')"
          >
            Archivados
          </v-btn>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <v-row class="mt-4">
        <v-col cols="12" md="4">
          <v-text-field
            v-model="fecha_inicial"
            label="Fecha Inicial"
            type="date"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="fecha_final"
            label="Fecha Final"
            type="date"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="mt-4">
          <v-btn
            color="gray"
            class="mb-1"
            @click="getConteosArchivados()"
            :disabled="!fecha_inicial || !fecha_final"
          >
            Buscar
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-tabs v-model="selectedTab" color="teal lighten-3 accent-4" left>
      <v-tab
        v-for="sucursal in itemsSucursalesDisponibles"
        :key="sucursal.sucursal"
      >
        <div>
          {{ sucursal.sucursal }}
        </div>
      </v-tab>
      <v-tab-item
        :disabled="true"
        v-for="(sucursal, index) in itemsSucursalesDisponibles"
        :key="index"
      >
        <v-data-table
          :headers="headers"
          :items="sucursal.conteos"
          :search="search"
          :footer-props="{
            'items-per-page-text': 'Conteos por página',
            'items-per-page-all-text': 'Todos',
          }"
          :header-props="{ 'sort-by-text': 'Ordenar por' }"
          :item-class="colorFila"
          no-data-text="No se encontraron conteos"
          no-results-text="No se encontraron conteos"
        >
          <template v-slot:[`item.fecha_creacion`]="{ item }">
            {{ formatoFecha(item.fecha_creacion) }}
          </template>
          <template v-slot:[`item.usuario`]="{ item }">
            {{ getNombreUsuario(item.usuario) }}
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      ItemsConteos: [],
      itemsSucursalesDisponibles: [],
      selectedTab: 0,
      search: "",
      usuarios: [],
      fecha_inicial: moment().subtract(60, "days").format("YYYY-MM-DD"),
      fecha_final: moment().add(1, "days").format("YYYY-MM-DD"),

      selectedOption: "archivados",

      headers: [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Sucursal",
          value: "sucursal",
        },
        {
          text: "Tipo",
          value: "tipo",
        },
        {
          text: "Referencia",
          value: "referencia",
        },
        {
          text: "Codigo Almacen",
          value: "codigo_almacen",
        },
        {
          text: "Creado por",
          value: "usuario",
        },
        {
          text: "Fecha de creación",
          value: "fecha_creacion",
        },
      ],

      ordenSucursales: [
        "Mexicali",
        "Tijuana",
        "Ensenada",
        "LaPaz",
        "Obregon",
        "Hermosillo",
      ],
    };
  },
  methods: {
    async getConteosArchivados() {
      try {
        const response = await axios.get(
          `/conteos/get_archivados?fecha_inicial=${this.fecha_inicial}&fecha_final=${this.fecha_final}`
        );
        const data = response.data;

        this.itemsSucursalesDisponibles = this.ordenSucursales
          .filter((nombre) => data[nombre])
          .map((nombre) => ({ sucursal: nombre, conteos: data[nombre] }));
      } catch (error) {
        console.log(error);
      }
    },

    async getUsuarios() {
      try {
        const response = await axios.get(`/usuarios/get_usuarios`);
        this.usuarios = response.data.usuarios;
      } catch (error) {
        console.error(error);
        return "Desconocido";
      }
    },

    getNombreUsuario(id) {
      const usuario = this.usuarios.find((u) => u.id === id);
      return usuario ? usuario.nombre : "Desconocido";
    },

    filtrarItems() {
      const busqueda = this.search.toLowerCase();
      return this.itemsSucursalesDisponibles.filter((item) =>
        item.sucursal.toLowerCase().includes(busqueda)
      );
    },

    formatoFecha(fecha) {
      //fecha con moment
      return moment(fecha).format("DD/MM/YYYY");
    },
    irA(ruta) {
      this.$router.push(ruta);
    },
  },
  computed: {
    ...mapGetters(["user", "currentUser"]),
    colorFila() {
      return function (item) {
        if (item.estado === "abierto") {
          return "green lighten-4";
        }
        if (item.estado === "archivado") {
          return "yellow lighten-4";
        }
        if (item.estado === "cerrado") {
          return "red lighten-4";
        }
      };
    },
  },
  watch: {},
  mounted() {
    this.getConteosArchivados();
    this.getUsuarios();
  },
  async created() {},
  beforeDestroy() {},
  components: {},
};
</script>

<style></style>
